import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash';
import { IRolePermissions } from '@/store/modules/userRoles/types';
import { computed, ref, watch } from 'vue';
import useStore from '@/utils/store/common';
import Modal from './components/Modal/Modal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
  role: {
    type: Object,
    default: () => ({} as IRolePermissions)
  }
},
  emits: ['edition-enabled', 'save', 'reload'],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();





const editionData = ref({} as IRolePermissions);

const getError = computed(() => store.getters['userRoles/getError']);

const edition = computed({
  get() {
    return store.getters['userRoles/getEdition'];
  },
  set(mode: boolean) {
    store.dispatch('userRoles/setEdition', mode);
    if (mode) {
      emit('edition-enabled');
    }
  }
});

const getTranslatedError = computed(() => {
  const err = getError.value;
  if (err.value === 'This user role already exists, please enter a different role name.') {
    return 'access.user_role.error.duplicate';
  }
  if (err.value === 'This user role name contains forbidden characters, please use only letters, digits, dot or dash.') {
    return 'access.user_role.error.forbidden';
  }
  return 'device.list.item.unknow';
});

const modalData = ref({
  headline: 'access.user_role.buttons.delete.title',
  text: 'access.user_role.buttons.delete.subtitle',
  actions: {
    continue: {
      text: 'access.user_role.buttons.delete.actions.confirm',
      caller: () => {
        if (editionData.value) {
          store.dispatch('userRoles/deleteUserRole', editionData.value.id);
        }
        modalData.value.display = false;
      }
    },
    cancel: {
      text: 'access.user_role.buttons.delete.actions.cancel',
      caller: () => { modalData.value.display = false; }
    }
  },
  display: false
});

function getCurrentUserIsAbleToWrite(featureName: string) {
  return featureName ? store.getters['permissions/getCurrentUserIsAbleTo']('write', featureName) : false;
}

function handleSave() {
  emit('save', editionData.value);
}

function handleCancel() {
  edition.value = false;
  editionData.value = _.cloneDeep(props.role as IRolePermissions);
  if (editionData.value) {
    store.dispatch('userRoles/fetchPermissionsOfRole', editionData.value.id);
  }
  emit('reload');
}

function handleDelete() {
  modalData.value.display = true;
}

watch(
  () => props.role,
  () => {
    editionData.value = _.cloneDeep(props.role as IRolePermissions);
    store.dispatch('userRoles/setError', undefined);
  },
  {
    immediate: true
  }
);

return { __sfc: true,store, props, emit, editionData, getError, edition, getTranslatedError, modalData, getCurrentUserIsAbleToWrite, handleSave, handleCancel, handleDelete, Modal }
}

})